// 404 Codes
export const GQL_RESPONSE_EMPTY = "GQL_RESPONSE_EMPTY";

export const RA_PID_MISSING = "REGIONAL_ACCURACY_404_PID_MISSING";

export const RA_PID_COUNTRY_NOT_MAPPED =
  "REGIONAL_ACCURACY_404_PID_COUNTRY_NOT_MAPPED";

export const RA_PID_LOCALE_INELIGIBLE =
  "REGIONAL_ACCURACY_404_PID_LOCALE_INELIGIBLE";

export const RA_PID_OOS = "REGIONAL_ACCURACY_404_PID_OOS";

export const RA_CATEGORY_AND_PRODUCT_UID_EMPTY =
  "REGIONAL_ACCURACY_404_PDP_URL_CATEGORY_AND_PRODUCT_UNIFIEDIDS_EMPTY";

export const RA_CATEGORY_UID_EMPTY =
  "REGIONAL_ACCURACY_404_PDP_URL_CATEGORY_UNIFIEDID_EMPTY";

export const RA_PRODUCT_UID_EMPTY =
  "REGIONAL_ACCURACY_404_PDP_URL_PRODUCT_UNIFIEDID_EMPTY";

// 3XX Codes
export const RA_PID_LOCALE_REDIRECT =
  "REGIONAL_ACCURACY_3XX_PID_LOCALE_REDIRECT";

export const RA_PRODUCT_AND_CATEGORY_MISMATCH =
  "REGIONAL_ACCURACY_3XX_PDP_URL_PRODUCT_AND_CATEGORY_MISMATCH";

export const RA_CATEGORY_MISMATCH =
  "REGIONAL_ACCURACY_3XX_PDP_URL_CATEGORY_MISMATCH";

export const RA_PRODUCT_MISMATCH =
  "REGIONAL_ACCURACY_3XX_PDP_URL_PRODUCT_MISMATCH";

export const RA_UNIFIEDID_MISSING_CA_REDIRECT =
  "RA_UNIFIEDID_MISSING_CA_REDIRECT";
